TooltipDirective.$inject = [];
function TooltipDirective() {
    return {
        restrict: 'A',
        scope: {
            tooltip: '@',
            position: '@tooltipPosition'
        },
        link: function (scope, element) {
            var tooltipEl;
            element.on('mouseenter', function () {
                if (!scope.tooltip) {
                    return;
                }
                var pos = scope.position || 'top';
                tooltipEl = angular.element('<div class="ng-tooltip ' + pos + '">' + scope.tooltip + '</div>');
                document.body.appendChild(tooltipEl[0]);
                var rect = element[0].getBoundingClientRect();
                var tipRect = tooltipEl[0].getBoundingClientRect();
                var top, left;
                switch (pos) {
                    case 'bottom':
                        top = rect.bottom + 10;
                        left = rect.left + rect.width / 2 - tipRect.width / 2;
                        break;
                    case 'left':
                        top = rect.top + rect.height / 2 - tipRect.height / 2;
                        left = rect.left - tipRect.width - 10;
                        break;
                    case 'right':
                        top = rect.top + rect.height / 2 - tipRect.height / 2;
                        left = rect.right + 10;
                        break;
                    case 'top':
                    default:
                        top = rect.top - tipRect.height - 10;
                        left = rect.left + rect.width / 2 - tipRect.width / 2;
                        break;
                }
                tooltipEl.css({ top: top + 'px', left: left + 'px' });
            });
            element.on('mouseleave', function () {
                if (tooltipEl) {
                    tooltipEl.remove();
                    tooltipEl = null;
                }
            });
        }
    };
}
angular.module('rinca.core.directives.tooltip', [])
    .directive('tooltip', TooltipDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/TooltipDirective.js
// module id = 318
// module chunks = 0